'use strict';
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
Object.defineProperty(exports, '__esModule', { value: true });
const form_1 = require('../contexts/form');
let timeout;
const wait = seconds =>
  new Promise(res =>
    setTimeout(() => {
      res();
    }, 1000 * seconds)
  );
function useStatusHandler() {
  const { setState } = (0, form_1.useInternalForm)();
  return state =>
    __awaiter(this, void 0, void 0, function* () {
      // add the pending status before other states
      if (state === 'PENDING') {
        setState(s =>
          Object.assign(Object.assign({}, s), { status: 'PENDING' })
        );
        timeout = wait(1);
        return;
      }
      if (timeout) {
        yield timeout;
        setState(s => Object.assign(Object.assign({}, s), { status: state }));
      } else {
        setState(s => Object.assign(Object.assign({}, s), { status: state }));
      }
      // if we are setting the status to success or error, wait 1000ms and then reset the status
      if (state === 'SUCCESS') {
        setTimeout(
          () =>
            __awaiter(this, void 0, void 0, function* () {
              if (timeout) yield timeout;
              setState(s =>
                Object.assign(Object.assign({}, s), { status: 'WAITING' })
              );
            }),
          1500
        );
      }
      if (state === 'ERROR') {
        setTimeout(
          () =>
            __awaiter(this, void 0, void 0, function* () {
              if (timeout) {
                yield timeout;
                yield wait(1);
              }
              setState(s =>
                Object.assign(Object.assign({}, s), { status: 'CHANGED' })
              );
            }),
          1500
        );
      }
    });
}
exports.default = useStatusHandler;
//# sourceMappingURL=useStatusHandler.js.map
